var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-whales"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.125 18.125L3.63141 18.1374C3.12875 18.1374 2.72125 17.7731 2.72125 17.3236V2.67536C2.72125 2.22592 3.12875 1.86157 3.63141 1.86157H16.3737C16.8764 1.86157 17.2838 2.22592 17.2838 2.67536V8.125",
    stroke: "#19233C",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.625 10L9.375 10",
    stroke: "#19233C",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.625 6.25L13.125 6.25",
    stroke: "#19233C",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.0765 14.4108C12.6804 14.4108 11.545 13.2815 11.545 11.8929C11.545 10.5044 12.6804 9.375 14.0765 9.375C15.4725 9.375 16.608 10.5044 16.608 11.8929C16.608 13.2815 15.4725 14.4108 14.0765 14.4108ZM14.0765 10.31C13.6519 10.31 13.2447 10.4777 12.9445 10.7763C12.6443 11.0749 12.4757 11.4799 12.4757 11.9022C12.4757 12.3244 12.6443 12.7294 12.9445 13.028C13.2447 13.3266 13.6519 13.4944 14.0765 13.4944C14.501 13.4944 14.9082 13.3266 15.2084 13.028C15.5086 12.7294 15.6773 12.3244 15.6773 11.9022C15.6773 11.4799 15.5086 11.0749 15.2084 10.7763C14.9082 10.4777 14.501 10.31 14.0765 10.31ZM16.729 18.8542H11.396C10.6236 18.8542 10 18.2339 10 17.4656V16.364C10 15.5957 10.6236 14.9755 11.396 14.9755H16.729C17.5014 14.9755 18.125 15.5957 18.125 16.364V17.4656C18.125 18.2339 17.4921 18.8542 16.729 18.8542ZM11.396 15.9012C11.1355 15.9012 10.9307 16.1048 10.9307 16.364V17.4656C10.9307 17.7248 11.1355 17.9285 11.396 17.9285H16.729C16.9895 17.9285 17.1943 17.7248 17.1943 17.4656V16.364C17.1943 16.1048 16.9895 15.9012 16.729 15.9012H11.396Z",
    fill: "#45A0F0",
    stroke: "#45A0F0",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionContract);
export default __webpack_public_path__ + "static/media/action-contract.611336e883002bd849bbf122c0ed4d27.svg";
export { ForwardRef as ReactComponent };